import type { ApplicationType } from "./tracking";

// Map surveyDefinitionUrl to simplified type for URL
export function mapSurveyTypeForUrl(
  surveyDefinitionUrl: string,
): ApplicationType {
  if (surveyDefinitionUrl.startsWith("mentor")) {
    return "mentor";
  } else if (surveyDefinitionUrl === "protege-spouse") {
    return "spouse";
  } else if (surveyDefinitionUrl === "protege") {
    return "veteran";
  }
  // Default fallback
  return "veteran";
}
